import React, { useEffect, memo } from 'react';
import { Form, Button, Drawer, Col, Row, Select, Skeleton, Input } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { activeAllClient } from 'pages/Client/action';
import { addEmail, editEmail } from 'pages/Addons/AddEmail/action';
import { activeAllOrder } from 'pages/Orders/action';
const { Option } = Select;

function AddAddonEmailDrawer({ initialState, clientInitialState, selectedEmail, editUserEmail, orderInitialState, resetPagination, roleAddResponsibility }) {
  const dispatch = useDispatch();
  const clientState = useSelector((state) => state.client || clientInitialState);
  const orderState = useSelector((state) => state.order || orderInitialState);
  const emailState = useSelector((state) => state.email || initialState);
  const [form] = Form.useForm();

  const toggleEmailDrawer = (open = false) => {
    form.resetFields();
    editUserEmail(null);
  };
  if (!_.isNil(selectedEmail)) {
    form.setFieldsValue({
      email: selectedEmail.email,
      password: selectedEmail.password,
      order_id: selectedEmail.order_id,
      client_id: selectedEmail.client_id,
      isactive: selectedEmail.isactive,
    });
  } else {
    form.setFieldsValue({
      isactive: true,
    });
  }

  useEffect(() => {
    if (emailState.drawer) { dispatch(activeAllClient()) }
  }, [clientState.drawer]);

  useEffect(() => {
    if (emailState.drawer) { dispatch(activeAllOrder()) }
  }, [orderState.drawer]);

  const handleEmail = () => {
    form.validateFields().then((values) => {
      values.isactive = _.isNil(values.isactive) || !values.isactive ? false : true;

      if (selectedEmail) {
        const { id } = selectedEmail;
        dispatch(editEmail({ id, ...values }));
      } else {
        dispatch(addEmail(values));
      }
    });

    resetPagination();
  };
  return (
    <div>
      {roleAddResponsibility ? (
        <Button onClick={() => toggleEmailDrawer()} size="medium" style={{ backgroundColor: "#00916c", borderColor: "#00916c", color: "white" }}>
          Add Email
        </Button>
      ) : (
        ''
      )}

      <Drawer
        title={selectedEmail ? `Edit` : `Add`}
        width={800}
        destroyOnClose={true}
        onClose={() => toggleEmailDrawer()}
        visible={emailState.drawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button onClick={() => toggleEmailDrawer()} loading={emailState.loading} disabled={emailState.loading} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button onClick={() => handleEmail()} loading={false} disabled={emailState.loading} style={{ backgroundColor: "#00916c", borderColor: "#00916c", color: "white" }}>
              {selectedEmail ? 'Edit' : 'Save'}
            </Button>
          </div>
        }
      >
        <Skeleton
          loading={orderState.loading && clientState.loading && emailState.loading}
          active={orderState.loading && clientState.loading && emailState.loading}
        >
          <Form form={form} layout="vertical" initialValues={{ remember: false }}>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="client_id"
                  label="Select Client"
                  initialValue={selectedEmail?.client_id}
                  rules={[{ required: true, message: 'Please select client' }]}
                >
                  <Select placeholder="Select client" loading={clientState.loading}>
                    {clientState.activeallClients.map((cat) => (
                      <Option value={cat.client_id} key={cat.client_id}>
                        {cat.client_name} {cat.last_name} ({cat.client_id})
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {/* <Row>
              <Col span={24}>
                <Form.Item
                  name="order_id"
                  label="Order ID"
                  rules={[{ required: true, message: 'Please enter order id' }]}
                >
                  <Input placeholder="Please enter order id" disabled={emailState.loading} />
                </Form.Item>
              </Col>
            </Row> */}
            <Row>
              <Col span={24}>
                <Form.Item
                  name="order_id"
                  label="Select Order"
                  initialValue={selectedEmail?.order_id}
                  rules={[{ required: true, message: 'Please select order' }]}
                >
                  <Select placeholder="Select Order" loading={orderState.loading}>
                    {orderState.activeallOrders.map((cat) => (
                      <Option value={cat.order_id} key={cat.order_id}>
                        ({cat.order_id}) {cat.productname} ({cat.client_name})
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[{ required: true, message: 'Please enter Email' }]}
                >
                  <Input placeholder="Please enter email" disabled={emailState.loading} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: true, message: 'Please enter password' }]}
                >
                  <Input placeholder="Please enter password" disabled={emailState.loading} />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item name="isactive" label="Status">
                  <Select placeholder="Status" defaultValue={true}>
                    <Option value={true}>Active</Option>
                    <Option value={false}>Inactive</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Skeleton>
      </Drawer>
    </div>
  );
}

export default memo(AddAddonEmailDrawer);
